import type { S3Object } from '../../../../drive/types';

export const getSourceDirectory = (sourceKey: string): string => {
  const lastSlashIndex = sourceKey.lastIndexOf('/');
  if (lastSlashIndex === -1) return ''; // File is in root
  return sourceKey.substring(0, lastSlashIndex); // Path without trailing slash
};

const normalizeDirectoryPath = (path: string): string => {
  if (!path) return '';
  return path.endsWith('/') ? path : `${path}/`;
};

export const checkDestinationConflict = (
  workspaceObjects: S3Object[] | undefined,
  destinationPath: string,
  fileName: string
): boolean => {
  if (!workspaceObjects) return false;

  const normalizedPath = normalizeDirectoryPath(destinationPath);
  const destinationKey = `${normalizedPath}${fileName}`;

  return workspaceObjects.some((obj) => obj.Key === destinationKey);
};

export interface ValidationState {
  isDestinationSameAsSource: boolean;
  hasConflict: boolean;
  hasPermissionError: boolean;
  canProceed: boolean;
}

export const validateCopyMoveOperation = (
  sourceKey: string,
  destinationPath: string,
  fileName: string,
  workspaceObjects: S3Object[] | undefined,
  isCrossWorkspace: boolean,
  hasWritePermission: boolean
): ValidationState => {
  const sourceDirectory = getSourceDirectory(sourceKey);
  const isDestinationSameAsSource = destinationPath === sourceDirectory && !isCrossWorkspace;
  const hasConflict =
    checkDestinationConflict(workspaceObjects, destinationPath, fileName) && !isDestinationSameAsSource;
  const hasPermissionError = isCrossWorkspace && !hasWritePermission;

  const canProceed = !isDestinationSameAsSource && !hasConflict && !hasPermissionError;

  return {
    isDestinationSameAsSource,
    hasConflict,
    hasPermissionError,
    canProceed,
  };
};
